const Reflux = require("reflux");
const biAPI = require("app/util/api/bi-api");
const dateToParam = require("./util/date-to-param").dateToParam;

const LostDealsActions = Reflux.createActions({
  "fetchData": { children: ["completed", "failed"] }
});

LostDealsActions.fetchData.listen(function(period, comparison, users, funnel) {
  let params = {
    start_date: dateToParam(period.startDate),
    end_date: dateToParam(period.endDate),
    comparison_start_date: dateToParam(comparison.startDate),
    comparison_end_date: dateToParam(comparison.endDate),
    users: users,
    funnel: funnel
  };

  biAPI.fetch("/lost_deals", params, this.completed, this.failed);
});

module.exports = LostDealsActions;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/actions/lost-deals-actions.js